<div (mousemove)="onMouseMove($event)"
  (mouseup)="onMouseAction($event)">
  <div class="view360-menu" [ngClass]="{'is-scroll':isPageScrolled}" #view360Menu [ngStyle]="{'width': getNewWidthView360Menu()}">
    <div class="view360"  [ngClass]="{'is-small' : isSmallView360Menu}">
      <div class="view360_header">
        <div class="view360_header-content">
          @if (hasRetour()) {
            <div class="button-white-icon" (click)="retourAction()">
              <i class="icon icon-arrow-left"></i>
            </div>
          }
          <h2 class="view360_title">{{titre}}</h2>
        </div>
      </div>
      <div class="view360_nav">
        <div class="view360_nav-list">
          <ng-content select="[menuItems]"></ng-content>
        </div>
      </div>
    </div>
    <div class="view360_resize" (mousedown)="onMouseAction($event)" [ngClass]="{'is-small' : isSmallView360Menu, 'is-active' : isMouseDown}">
      <div class="view360_resize-btn" (click)="toggleResizeView360Menu()" >
        <i class="icon icon-chevron-left"></i>
      </div>
    </div>
  </div>
  <div class="view360_aside" #view360Position [ngStyle]="{'width': 'calc(100% - '+getNewWidthView360Menu()+')', 'margin-left': getNewWidthView360Menu()}">
    <ng-container *ngTemplateOutlet="pageContent" ></ng-container>
  </div>
</div>
